import Container from "react-bootstrap/Container";
import {Card, Modal, Nav, Navbar, Row} from "react-bootstrap";
import Tooltip from "@mui/material/Tooltip";
import {Link, useNavigate} from "react-router-dom";
import Image from "react-bootstrap/Image";
import React, {useContext, useState} from "react";
import {LykioContext} from "../routing/LykioAuthorizedRoute";
import lykio_logo from "../../multimedia/Default/white_loading.gif";
import Col from "react-bootstrap/Col";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import LogoutIcon from "@mui/icons-material/LogoutSharp";
import t from "../../Utils/Translation";
import {FRONTEND_LOGIN_URL, LANGUAGES_ARRAY} from "../../Utils/Constants";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import {Box} from "@mui/material";
import {makeStyles} from "@material-ui/core";
import PDFModal from "../guides/PDFModal";
import changeLanguage from '../../locales/translations/TranslationUtils';
import Form from 'react-bootstrap/Form';
import FloatingLabel from "react-bootstrap/FloatingLabel";

const useStyles = makeStyles((theme) => ({
    tabs: {
        "& .MuiTabs-indicator": {
            display: "none"
        },
    },
    root: {
        backgroundColor: '#5b975f !important',
        color: '#fff !important',
        '&:hover': {
            backgroundColor: '#235227 !important',
        },
        marginRight: '20px !important'
    },
    selected: {
        backgroundColor: '#235227 !important',
        color: '#fff !important',
        marginRight: '20px !important'
    },
}));
const GreenWave = (props) => {
    const context = useContext(LykioContext)
    const navigate = useNavigate();
    const userPermissions = context.userPermissions;
    const categories = context.categories;
    const tenantProperties = context.tenantProperties;
    const userDetails = context.userDetails;
    const logo = "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/assets/logo_greenwave_sm.png"

	const languages = (tenantProperties && tenantProperties.languages && tenantProperties.languages.length>0) ? tenantProperties.languages : LANGUAGES_ARRAY;
	const [ systemLanguage, setSystemLanguage ] = useState(languages[0].code);


    const [showIntro, setShowIntro] = useState(true);
    const [showModal, setShowModal] = useState(false)
    const [currentModalToShow, setCurrentModalToShow] = useState(null)

    const [value, setValue] = useState('All');

    const classes = useStyles();


    const handleChange = (event, newValue) => {
        setValue(newValue);
    };



    const logout = () => {
        localStorage.removeItem('authToken');
        localStorage.removeItem('showToastNotificationsToken');
        localStorage.removeItem('user');
        localStorage.removeItem('userId');
        localStorage.removeItem('localThemeName');
        localStorage.removeItem('localShowBackgroundImages');
        localStorage.removeItem('localbackgroundImage');
        localStorage.removeItem('localca');
        localStorage.removeItem('userRole');
        localStorage.removeItem('teacherbookActivated');
        localStorage.removeItem('studentbookActivated');
        localStorage.removeItem('workbookActivated');
        localStorage.removeItem('levelIsActivated');
        navigate(FRONTEND_LOGIN_URL);
    };

    const intro = ''
    const modules = [
        {
            category: 'Entrepreneurial',
            cover: 'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md1-0.png',
            coverTitle: t('TAKING AN ACTIVE BUSINESS STAND FOR THE ENVIRONMENT'),
            title: t('TAKING AN ACTIVE BUSINESS STAND FOR THE ENVIRONMENT'),
            rubric: t('Focus on each photo separately'),
            images: [
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md1-1.png',
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md1-2.png',
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md1-3.png'
            ]
        },
        {
            category: 'Entrepreneurial',
            cover: 'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md2-0.png',
            coverTitle: t('LEGAL ESTABLISHMENT OF A BUSINESS – TYPES AND PROCEDURES'),
            title: t('LEGAL ESTABLISHMENT OF A BUSINESS – TYPES AND PROCEDURES'),
            rubric: t('Focus on each photo separately'),
            images: [
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md2-1.png',
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md2-2.png',
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md2-3.png'
            ]
        },
        {
            category: 'Entrepreneurial',
            cover: 'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md3-0.png',
            coverTitle: t('SUSTAINABILITY AND UNSUSTAINABILITY'),
            title: t('SUSTAINABILITY AND UNSUSTAINABILITY'),
            rubric: t('Focus on each photo separately'),
            images: [
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md3-1.png',
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md3-2.png',
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md3-3.png'
            ]
        },
        {
            category: 'Entrepreneurial',
            cover: 'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md4-0.png',
            coverTitle: t('SYSTEM THINKING & SOLVING PROBLEMS VIA BUSINESS AND PROCESS APPROACH'),
            title: t('SYSTEM THINKING & SOLVING PROBLEMS VIA BUSINESS AND PROCESS APPROACH'),
            rubric: t('Focus on each photo separately'),
            images: [
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md4-1.png',
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md4-2.png',
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md4-3.png'
            ]
        },
        {
            category: 'Green',
            cover: 'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md5-0.png',
            coverTitle: t('SHORT AND LONG TERM IMPACT ON THE PLANET – MEASURING THE FOOTPRINT'),
            title: t('SHORT AND LONG TERM IMPACT ON THE PLANET – MEASURING THE FOOTPRINT'),
            rubric: t('Focus on each photo separately'),
            images: [
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md5-1.png',
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md5-2.png',
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md5-3.png'
            ]
        },
        {
            category: 'Green',
            cover: 'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md6-0.png',
            coverTitle: t('PROMOTING NATURE'),
            title: t('PROMOTING NATURE'),
            rubric: t('Focus on each photo separately'),
            images: [
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md6-1.png',
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md6-2.png',
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md6-3.png'
            ]
        },
        {
            category: 'Entrepreneurial',
            cover: 'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md7-0.png',
            coverTitle: t('CRITICAL THINKING SKILLS – STRATEGIES FOR DEVELOPMENT & INFORMATION MANAGEMENT'),
            title: t('CRITICAL THINKING SKILLS – STRATEGIES FOR DEVELOPMENT & INFORMATION MANAGEMENT'),
            rubric: t('Focus on each photo separately'),
            images: [
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md7-1.png',
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md7-2.png',
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md7-3.png'
            ]
        },
        {
            category: 'Entrepreneurial',
            cover: 'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md8-0.png',
            coverTitle: t('THE FUTURE OF GREEN OPPORTUNITIES – MARKET EXPLORATION STRATEGIES'),
            title: t('THE FUTURE OF GREEN OPPORTUNITIES – MARKET EXPLORATION STRATEGIES'),
            rubric: t('Focus on each photo separately'),
            images: [
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md8-1.png',
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md8-2.png',
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md8-3.png'
            ]
        },
        {
            category: 'Green',
            cover: 'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md9-0.png',
            coverTitle: t('CREATION OF GREEN BUSINESS PLAN, GREEN FINANCIAL PLAN'),
            title: t('CREATION OF GREEN BUSINESS PLAN, GREEN FINANCIAL PLAN'),
            rubric: t('Focus on each photo separately'),
            images: [
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md9-1.png',
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md9-2.png',
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md9-3.png'
            ]
        },
        {
            category: 'Green',
            cover: 'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md10-0.png',
            coverTitle: t('IMPLEMENTATION OF CIRCULAR ECONOMY'),
            title: t('IMPLEMENTATION OF CIRCULAR ECONOMY'),
            rubric: t('Focus on each photo separately'),
            images: [
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md10-1.png',
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md10-2.png',
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md10-3.png'
            ]
        },
        {
            category: 'Green',
            cover: 'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md11-0.png',
            coverTitle: t('STAFF RECRUITMENT & GREEN JOBS'),
            title: t('STAFF RECRUITMENT & GREEN JOBS'),
            rubric: t('Focus on each photo separately'),
            images: [
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md11-1.png',
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md11-2.png',
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md11-3.png'
            ]
        },
        {
            category: 'Green',
            cover: 'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md12-0.png',
            coverTitle: t('ECO MINDSET IN THE BUSINESS'),
            title: t('ECO MINDSET IN THE BUSINESS'),
            rubric: t('Focus on each photo separately'),
            images: [
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md12-1.png',
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md12-2.png',
                'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/md12-3.png'
            ]
        }

    ]

    const filteredModules = modules.filter((module) =>
        value === 'All' ? true : module.category === value
    );
    const handleOpenModule = (module) => {
        setCurrentModalToShow(module);
        setShowModal(true)
    }

    const handleCloseModule = () => {
        setShowModal(false)
        setShowIntro(true)
    }
    return (
        <>
            <Navbar style={{ backgroundColor: '#5b975f', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',paddingTop: 0,paddingBottom:0,  borderBottom: '5px solid rgba(0, 0, 0, 0.1)'}} variant={'light'} expand={'lg'}>
                <Navbar.Brand href="/" style={{paddingTop: 0, paddingBottom: 0, marginLeft: '20px'}}>
                    <img
                        src={logo}
                        alt="GreenWave"
                        style={{width: '120px', height: 'auto'}}
                    />
                </Navbar.Brand>
                <Nav className={'mx-auto'}>
                    <Nav.Item>
                        <h4 className={'my-auto'} style={{color: "#d7e3d7", fontWeight: '600'}} >
                            {t('Modules')}
                        </h4>
                    </Nav.Item>
                </Nav>
                <Nav className="ml-auto" style={{padding:'0 1rem 0 1rem'}}>
                    <Form.Group controlId="systemLanguage" >
						<Form.Select onChange={(e) => { setSystemLanguage(e.target.value); changeLanguage(e.target.value) }}>
							{languages.map((language) => (
								<option
									selected = {systemLanguage===language.code}
									value={language.code}
								>
									{t(language.name)}
								</option>
							))}
						</Form.Select>
					</Form.Group>
                </Nav>     
                <Nav className="ml-auto">
                    <PDFModal buttonStyle={{ color: "#d7e3d7", borderColor: "#d7e3d7" }}/>
                </Nav>
                <Nav className="ml-auto">
                    <Nav.Item>
                        <Nav.Link >
                            <Typography sx={{ p: 2 }}>
                                <a className="lykiocss-meta-anchor" style={{color: "#d7e3d7"}}
                                   onClick={() => {
                                       logout();
                                   }}
                                >
                                    <div><LogoutIcon/> {t('Logout')}</div>
                                </a>
                            </Typography>
                        </Nav.Link>

                    </Nav.Item>
                </Nav>
            </Navbar>
            <Container>
                
            </Container>
            <Container className={'greenwave-background lykioccs-main-content'}>
                 <Row>
                    <div className="lykiocss-center lykiocss-margin-top-1em" >
                        <h3 style={{ color: '#235227' }}>{t('Select a Module before opening the AR Game')}</h3>
                    </div>


                 </Row>
                <Box sx={{ width: '100%', mt: 3}}>
                    <Tabs value={value} onChange={handleChange} centered className={classes.tabs}>
                        <Tab value="All" label={t('All')}
                             className={value === "All" ? classes.selected : classes.root}
                        />
                        <Tab value="Entrepreneurial" label={t('Entrepreneurial')}
                             className={value === "Entrepreneurial" ? classes.selected : classes.root}
                        />
                        <Tab value="Green" label={t('Green')}
                             className={value === "Green" ? classes.selected : classes.root}
                        />
                    </Tabs>
                </Box>

                <Row className="g-4 p-5">
                    {filteredModules.map((module, index) => (
                        <Col key={module.title} xs={12} sm={6} md={4} lg={3}>
                            <Card
                                className="custom-card"
                                onClick={() => handleOpenModule(module)}
                                style={{ cursor: 'pointer' }}
                            >
                                <div className="image-wrapper">
                                    <Card.Img
                                        className="custom-image"
                                        src={module.cover}
                                        alt={`Card image ${index + 1}`}
                                    />
                                    <div className="info-box">
                                        <div className="title-wrapper">
                                            <Card.Title className={'text-center title-box'}>
                                                {module.coverTitle}
                                            </Card.Title>
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>






            // in your Modal code

            <Modal show={showModal} onHide={handleCloseModule} dialogClassName={'modal-90w'} centered>
                {currentModalToShow && (
                    <>
                        <Modal.Header closeButton className="modal-header-footer-custom">
                            <Modal.Title style={{ color: '#d7e3d7' }}>{currentModalToShow.title}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="modal-body-custom h-100  d-flex  justify-content-center align-items-center">
                            {showIntro ? (
                                <div>
                                    <img 
                                        src={
                                            localStorage.getItem("i18n") === "en"
                                                ? 'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/help-all-en.png'
                                                : localStorage.getItem("i18n") === "bg"
                                                ? 'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/help-all-bul.png'
                                                : localStorage.getItem("i18n") === "pt"
                                                ? 'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/help-all-por.png'
                                                : localStorage.getItem("i18n") === "el"
                                                ? 'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/FTP/GreenWave/help-all-gr.png'
                                                : ''
                                        }
                                    alt='e' style={{ width: '100%', height: '70vh', objectFit: 'cover' }} />
                                </div>
                            ): (
                                <>
                                    <h4 style={{ color: '#235227', position: 'absolute', top: 50 }}>{currentModalToShow.rubric}</h4>
                                    <Row className="justify-content-around">
                                        {currentModalToShow.images.map((imageUrl, index) => (
                                            <Col key={index} md={4}  className="text-center">
                                                <img
                                                    src={imageUrl}
                                                    alt={'title'}
                                                    className="img-fluid"
                                                    style={{ maxHeight: '60vh', maxWidth: '80%', border: '4px solid white', objectFit: 'cover' }}
                                                />
                                            </Col>
                                        ))}
                                    </Row>
                                </>
                            )}
                        </Modal.Body>
                        {showIntro &&
                            <Modal.Footer className="modal-header-footer-custom">
                                <Button style={{background: 'rgb(5,83,57)', color: '#fff'}} className={'p-2'} onClick={() => setShowIntro(false)}>
                                    {t('Next')}
                                </Button>
                            </Modal.Footer>
                        }
                    </>
                )}
            </Modal>




        </>
    )
}

export default GreenWave



